import React, { Component } from "react";
import { connect } from "react-redux";
import { lang } from "../../config/lang";
import store from "../../store/configureStore";
import { addNotification } from "../../actions/notificationAction";
import { changeHomeSectionAction } from "../../actions/homeSectionAction";
import agencyApi from "../../api/agencyApi";
import AgencyBlock from "./AgencyBlock";

/****************************************
    Component for Agency Slider
    @author  IMH003
    @date    2020.05.10
    @version 0.1    
 ******************************************/
class AgencySlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            arrAgency: [],
        };

        this.getAgencies = this.getAgencies.bind(this);
    }

    componentWillMount() {}

    componentDidMount() {
        this.getAgencies(true);
    }

    componentWillUnmount() {}

    componentWillReceiveProps(newProps) {
        this.getAgencies(false);
    }

    getAgencies(isNew) {
        agencyApi.getAgencies().then((json) => {
            if (json.status === 200 && json.data) {
                this.setState({
                    arrAgency:
                        json.data.length > 6 && this.props.isPart === true
                            ? json.data.slice(0, 6)
                            : json.data,
                });
                window.contentWayPoint();
                if (isNew) {
                    window.initAgencySingleSlider();
                } else {
                    window.refreshAgencySingleSlider();
                }

                if (json.data.length > 0) {
                    store.dispatch(changeHomeSectionAction({ agency: true }));
                }
            } else {
                store.dispatch(
                    addNotification(`${lang("server_err")}`, "error")
                );
            }
        });
    }

    render() {
        if (this.state.arrAgency.length === 0) {
            return <div />;
        }

        return (
            <section
                className="ftco-section testimony-section"
                id="agency-section"
            >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 heading-section text-center ftco-animate">
                            <h2 className="mb-4 pb-3">{this.props.title}</h2>
                            <p>{this.props.sub_title}</p>
                        </div>
                    </div>
                    <div className="row justify-content-start">
                        <div className="col-md-12 heading-section ftco-animate">
                            <div className="row ftco-animate">
                                <div className="col-md-12">
                                    <div className="agency-slider owl-carousel">
                                        {this.state.arrAgency.map(
                                            (agency, key) => (
                                                <AgencyBlock
                                                    key={key}
                                                    id={agency.id}
                                                    title={agency.title}
                                                    description={
                                                        agency.description
                                                    }
                                                    mark_path={agency.mark_path}
                                                />
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language,
    };
}

export default connect(mapStateToProps)(AgencySlider);
